export default __webpack_public_path__ + "static/media/02.d3b20988.jpg";